import React from 'react'
import {connect} from 'react-redux'
import i18n from "../../../i18nSetup";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import {ROUTE_OPTIONS} from '../../constants';
import {settingQueryParam} from "../../actions/form";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import {TypographyBasic, TypographyMediumSize} from "../../styles/components/customTypography";
import Divider from "@mui/material/Divider";


function RouteOptions(props) {

    const handleRadioChange = (event) => {

        let routeOption = {};

        ROUTE_OPTIONS.forEach((route) => {
            Object.assign(routeOption, {[route.name]: route.key === event.target.value ? route.value : undefined})
        })
        props.settingQueryParam(routeOption)
    };

    const {query} = props;

    const getValueForRoute = () => {
        let routeOptionValue='';
        ROUTE_OPTIONS.forEach((route)=>{
            if(query[route.name]){
                routeOptionValue = route.key
            }
        })
        return routeOptionValue;
    };

    return (
      <Box>
          <Stack direction={'column'} spacing={1.5}>
              <Divider flexItem/>
              <TypographyMediumSize>
                  {i18n.t('routeOptions')}
              </TypographyMediumSize>
              <FormControl variant="standard" sx={{margin: 3}}>
                  <RadioGroup defaultValue={getValueForRoute()} onChange={handleRadioChange}>
                      {ROUTE_OPTIONS.map((route, index) => (
                        <FormControlLabel key={"routeOptions" + index} value={route.key}
                                          control={<Radio sx={{
                                              color: '#4B33A5',
                                              '&.Mui-checked': {
                                                  color: '#4B33A5',
                                              },
                                          }}/>}
                                          label={<TypographyBasic fw={400}>
                                              {i18n.t(route.key)}
                                          </TypographyBasic>}/>
                      ))}

                  </RadioGroup>
              </FormControl>
          </Stack>
      </Box>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {

        query: state.otp.currentQuery
    }
}
const mapDispatchToProps = {
    settingQueryParam
}
export default connect(mapStateToProps,mapDispatchToProps) (RouteOptions)